// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";
import "./turbo_confirm_actions";

import Alpine from "alpinejs";

window.Alpine = Alpine;
Alpine.start();
